import { useContext } from 'react';
import { TransactionHistoryContext } from './TransactionHistoryContext';
import { TransactionsHistoryHostProps } from './types';

export default function useTransactionHistory(): TransactionsHistoryHostProps {
  const value = useContext(TransactionHistoryContext);

  if (!value) {
    throw new Error(
      'useTransactionHistory: used outside the Transaction History feature root. Only internal feature components may call it.',
    );
  }

  return value;
}
